<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { computed } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
  output: unknown;
  errorText?: string | null;
  class?: HTMLAttributes["class"];
}>();

const showOutput = computed(() => props.output != null || !!props.errorText);

const isStringOutput = computed(() => typeof props.output === "string");

const formattedOutput = computed(() => {
  if (typeof props.output === "string") {
    return props.output;
  }
  try {
    return JSON.stringify(props.output, null, 2);
  } catch {
    return String(props.output);
  }
});
</script>

<template>
  <div v-if="showOutput" :class="cn('space-y-2 p-4', props.class)" v-bind="$attrs">
    <h4 class="font-medium text-muted-foreground text-xs uppercase tracking-wide">
      {{ props.errorText ? "Error" : "Result" }}
    </h4>
    <div
      :class="
        cn(
          'overflow-x-auto rounded-md text-xs',
          props.errorText ? 'bg-destructive/10 text-destructive' : 'bg-muted/50 text-foreground',
        )
      "
    >
      <div v-if="errorText" class="p-3 whitespace-pre-wrap break-words">{{ props.errorText }}</div>
      <pre
        v-else
        class="overflow-x-auto p-3"
      ><code :class="isStringOutput ? 'whitespace-pre-wrap break-words' : ''">{{ formattedOutput }}</code></pre>
    </div>
  </div>
</template>
